import React from 'react';
import classNames from 'classnames';

import s from './container.scss';

type PropsType = {
    children: React.ReactNode;
    dataTestName?: string | null;
    isAnimation?: boolean;
    isContactLenses?: boolean;
    className?: string;
};

/**
 * Category Item Container Component
 * @param {PropsType} props - component properties
 * @returns {React.FC<PropsType>} rendered component
 */
export const ItemContainer: React.FC<PropsType> = React.memo(
    ({
        children,
        dataTestName = null,
        isContactLenses = false,
        isAnimation = false,
        className,
    }): React.ReactElement => (
        <div
            data-test-name={dataTestName}
            className={classNames(
                s.container,
                {[s.animation]: isAnimation},
                {[s.lensesContainer]: isContactLenses},
                className,
            )}
        >
            {children}
        </div>
    ),
);
